import { render, staticRenderFns } from "./roleDetails.vue?vue&type=template&id=15e4d021"
import script from "./roleDetails.vue?vue&type=script&lang=js"
export * from "./roleDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports